import routes from '@/modules/plan/plan-routes';
import store from '@/modules/plan/plan-store';

export default {
  routes,
  store,
};
